<template>
  <LayoutGradient :title="$t('rnds.transmissao.titulo_pagina')" icon="fa-broadcast-tower">
    <div class="row m-3 mt-n10">
      <div class="col-lg-6 p-3">
        <b-card>
          <SimpleForm @submit="onSubmit" :fields="fields" :model="model"/>
        </b-card>
      </div>
      <div class="col-lg-6 p-3">
        <b-card :title="$t('rnds.transmissao.importacao_massa')">
          <b-card-body>
            <b-overlay :show="construcao" variant="white" spinner-variant="white">
              <template v-slot:overlay>
                <div class="text-center">
                  <p>{{ $t('rnds.transmissao.funcionalidade_contrucao') }}</p>
                  <b-button variant="outline-info" size="sm" @click="construcao = false">Okay</b-button>
                </div>
              </template>
              <b-form-file :placeholder="$t('rnds.transmissao.escolha_arquivo_importacao')"
                           :drop-placeholder="$t('rnds.transmissao.arraste_solte_arquivo')"
                           :browse-text="$t('rnds.transmissao.selecionar')"
                           v-model="model_bulk.file"/>
              <FieldGenerator class="mt-4" :field="{
                label: $t('rnds.transmissao.separador'),
                name: 'separador',
                type: 'select',
                options:[
                {value: 'tab', text: $t('rnds.transmissao.arquivo_importacao_valores.tab')},
                  {value: 'pipe', text: $t('rnds.transmissao.arquivo_importacao_valores.pipe')},
                  {value: 'space', text: $t('rnds.transmissao.arquivo_importacao_valores.espaco')},
                  {value: 'comma', text: $t('rnds.transmissao.arquivo_importacao_valores.virgula')},
                  {value: 'dot', text: $t('rnds.transmissao.arquivo_importacao_valores.ponto')},
                ]
              }" :model="model_bulk"/>
              <FieldGenerator class="mt-4" :field="{
                label: $t('rnds.transmissao.quantidade_coluna'),
                name: 'fieldsQuantity',
                type: 'number'
              }" :model="model_bulk"/>
              <b-button variant="success" type="button" block>
              <i class="fas fa-save"/> {{ $t('rnds.transmissao.importar') }}</b-button>

            </b-overlay>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </LayoutGradient>
</template>

<script>
import {mapActions} from "vuex";
import LayoutGradient from "@/templates/LayoutGradient";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import FieldGenerator from "@/components/FormGenerator/FieldGenerator";
import RndsRepository from "@/repositories/RndsRepository";
import Cookies from 'js-cookie'

export default {
  name: "Form",
  components: {FieldGenerator, SimpleForm, LayoutGradient},
  data() {
    return {
      construcao: true,
      fields: [
        {label: this.$t('rnds.transmissao.campos.cpf_label'), name: 'patient_identifier', description: this.$t('rnds.transmissao.campos.cpf_descricao'), required: true},
        {label: this.$t('rnds.transmissao.campos.cns_label'), name: 'cns_profissional', description: this.$t('rnds.transmissao.campos.cns_descricao'), required: true},
        {
          label: this.$t('rnds.transmissao.campos.exame_label'), name: 'code', type: 'select', required: true, options: [
            {value: 'CVIDGG', text: 'COVID-19, IgG'},
            {value: 'CVIDGM', text: 'COVID-19, IgM'},
          ]
        },
        {
          label: this.$t('rnds.transmissao.campos.resultado_label'), name: 'value_quantity', type: 'select', required: true, options: [
            {value: '1', text: this.$t('rnds.transmissao.campos.resultado_valores.detectavel')},
            {value: '2', text: this.$t('rnds.transmissao.campos.resultado_valores.nao_detectavel')},
            {value: '3', text: this.$t('rnds.transmissao.campos.resultado_valores.inconclusivo')},
          ]
        },
        {
          label: this.$t('rnds.transmissao.campos.amostra_biologica_label'), name: 'specimen_code', type: 'select', required: true, options: [
            {value: 'SECONF', text: 'Secreção Orofaríngea e Nasofaríngea'},
            {value: 'SNOF',   text: 'Swab Naso-Orofaríngeo'},
            {value: 'SWNAFA', text: 'Swab Nasofaríngeo'},
            {value: 'SWAB',   text: 'Swab'},
            {value: 'SWORO',  text: 'Swab Orofaríngeo'},
            {value: 'SWNAS',  text: 'Swab Nasal'},
          ]
        },
        {label: this.$t('rnds.transmissao.campos.data_label'), name: 'processed_at', type: 'date', description: this.$t('rnds.transmissao.campos.data_descricao'), required: true},
        {
          label: this.$t('rnds.transmissao.campos.uf_laboratorio_label'), name: 'uf_company', type: 'select', required: true, options: [
            {text: "Acre", value: "AC"},
            {text: "Alagoas", value: "AL"},
            {text: "Amapá", value: "AP"},
            {text: "Amazonas", value: "AM"},
            {text: "Bahia", value: "BA"},
            {text: "Ceará", value: "CE"},
            {text: "Distrito Federal", value: "DF"},
            {text: "Espírito Santo", value: "ES"},
            {text: "Goiás", value: "GO"},
            {text: "Maranhão", value: "MA"},
            {text: "Mato Grosso", value: "MT"},
            {text: "Mato Grosso do Sul", value: "MS"},
            {text: "Minas Gerais", value: "MG"},
            {text: "Pará", value: "PA"},
            {text: "Paraíba", value: "PB"},
            {text: "Paraná", value: "PR"},
            {text: "Pernambuco", value: "PE"},
            {text: "Piauí", value: "PI"},
            {text: "Rio de Janeiro", value: "RJ"},
            {text: "Rio Grande do Norte", value: "RN"},
            {text: "Rio Grande do Sul", value: "RS"},
            {text: "Rondônia", value: "RO"},
            {text: "Roraima", value: "RR"},
            {text: "Santa Catarina", value: "SC"},
            {text: "São Paulo", value: "SP"},
            {text: "Sergipe", value: "SE"},
            {text: "Tocantins", value: "TO"}
          ]
        },
      ],
      model: {
        result_id: "form_result_",
        code: null,
        value_quantity: null,
        specimen_code: null,
        processed_at: null,
        patient_identifier: null,
        cns_profissional: null,
        uf_company: null,
      },
      model_bulk: {
        file: null,
        separador: 'comma',
        fieldsQuantity: 0,
      }
    }
  },
  methods: {
    ...mapActions([
        'corecompanies/listInVs'
    ]),
    onSubmit() {
      const d = new Date();
      const d_string = d.toLocaleDateString() + d.toLocaleTimeString()
      const params = {
        device_name: `VNSSUS${this.model.uf_company}`,
        filename: 'result.json',
        report_content: JSON.stringify({
          exams: [
            {
              result_id: this.model.result_id + d_string,
              code: this.model.code,
              value_quantity: this.model.value_quantity,
              processed_at: this.model.processed_at
            }
          ],
          patient_identifier: this.model.patient_identifier,
          // company_id: this.model.company_id,
          company_id: Cookies.get('vws_veus_company_id'),
          cns_profissional: this.model.cns_profissional,
          uf_company: this.model.uf_company,
          specimen_code: this.model.specimen_code,
          reference_range: null,
          method_code: null,
          note: null
        })
      }
      RndsRepository.post(params).then(() => {
        this.$snotify.success(this.$t('rnds.transmissao.reporte_enviado'))
      }).catch(error => {
        this.$snotify.error(this.$t('rnds.transmissao.erro_reportar_exame'))
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
</style>